import axios from 'axios';
import qs from 'qs';

const rhfFormattedErrors = data => {
    const formattedErrors = {};

    const formatError = (obj, parentObj) => {
        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                if (typeof value[0] === 'object') {
                    parentObj[key] = {};
                    value.forEach((item, index) => {
                        parentObj[key][index] = {};
                        formatError(item, parentObj[key][index]);
                    });
                } else {
                    parentObj[key] = {
                        type: 'server',
                        message: value,
                    };
                }
            } else if (typeof value === 'object') {
                parentObj[key] = {};
                formatError(value, parentObj[key]);
            } else {
                parentObj[key] = {
                    type: 'server',
                    message: [value],
                };
            }
        });
    };

    formatError(data, formattedErrors);
    return formattedErrors;
};

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        'X-User-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    formSerializer: {
        indexes: true,
        visitor: (value, key, path, helpers) => {
            const formKey = path ? key : `[${key}]`;
            if (helpers.isArray(value) && value.length === 0) {
                return helpers.defaultVisitor('[]', formKey, path, helpers);
            }
            return helpers.defaultVisitor(value, formKey, path, helpers);
        },
    },
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 400) {
            error.response.data = rhfFormattedErrors(error.response.data);
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
